<div class="wrapper">
  <h1>404</h1>
  <h2>Oops! Page not found</h2>
  <p>
    The page you are looking for might have been removed, had its name changed,
    or is temporarily unavailable.
  </p>
  <a href="https://higift.com/">
    <button mat-raised-button color="primary">
        Back To Home
      </button>
  </a>
</div>
